import React, { useEffect, useState } from 'react';
import { Routes, useLocation, useNavigate } from "react-router-dom";
import Button, { ButtonModeE } from '../../../Button/Button';
import { useAuth } from "../../../../utils/hooks/useAuth";
import ProfileDropdown from "../ProfileDropdown/ProfileDropdown";
import ProfilePhoto from "../../../ProfilePhoto/ProfilePhoto";
import { isMobile } from '../../../../utils/helpers/mediaQueries';
import { RoutesE } from '../../../../routes/routesData';

import styles from "./profile.module.scss";

/**
 * Show login button if there are no logged users
 * Otherwise show user data.
 * */

const Profile = () => {
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [isLoginButtonVisible, setIsLoginButtonVisible] = useState(true);
    const location = useLocation();

    const navigateToLogin = () => {
        navigate(RoutesE.LOGIN);
    };

    const toggleDropdownVisibility = () => {
        setIsDropdownVisible(prev => !prev);
    };

    useEffect(() => {
        setIsLoginButtonVisible(location.pathname !== RoutesE.LOGIN);
    }, [location])
    
    return (
        <div className={styles.wrapper}>
            {!currentUser ? (
                <>
                    {isLoginButtonVisible && (
                        <Button
                            onClick={navigateToLogin}
                            mode={ButtonModeE.OUTLINED}
                            link={RoutesE.LOGIN}
                        >
                            Login
                        </Button>
                    )}
                </>
            ) : (
                <div className={styles.profileWrapper} onClick={toggleDropdownVisibility}>
                    <ProfilePhoto className={styles.mobileProfilePhoto} />
                    {!isMobile() ? (
                        <span className={styles.userName}>{currentUser.userName}</span>
                    ) : (
                        <span className={styles.userName} />
                    )}
                    {isDropdownVisible && (
                        <>
                            <ProfileDropdown currentUser={currentUser} onClose={() => setIsDropdownVisible(false)} />
                            <div className={styles.dropdownOverlay} />
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default Profile;